import { Link } from "react-router-dom";
import { GetCompras } from "../../actions/Compra.jsx";
import { GotoLogin } from "../../actions/renovarLog";

import style from "../../styles/grid.module.css";
import axios from "axios";
import { Pencil, SquareX, CirclePlus } from "lucide-react";
import { formatos } from "../../actions/formats.jsx";

const AbmCompras = () => {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "sqlraw/compra/";
   const compras = GetCompras();
   const filtroTipo = 1;
   const { formatoNumero } = formatos();

   const handleRemove = async (id) => {
      let text =
         "Se va a eliminar la compra selecionada!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         const response = await axios.delete(url + id, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });
         console.log("response: ", response);
         window.location.href = "/Compra";
      }
   };

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };

   if (compras?.message === "Token inválido") {
      return <GotoLogin />;
   }
   console.log("compras: ", compras);
   return (
      <>
         <div className={style.tableCli}>
            <div >
               <div>
                  <div className={style.gridTitle}>
                     <h2>Compras Productos para Piercing</h2>
                  </div>
               </div>
               <div>
                  <div>
                     <Link
                        to={"/formCompra"}
                        className="dLink"
                        title="Alta Compra"
                        state={{
                           id_primary: 0,
                           id: 0,
                           companyId: 0,
                           descripcion: "",
                           dolar: 0,
                           cod_status: 1,
                           stock: 0,
                        }}
                     >
                        <CirclePlus className="lucidePlus" />
                     </Link>
                  </div>
               </div>
               &nbsp;&nbsp;
            </div>
         </div>
         <div>
            <table style={{width:"70%"}}>
               <thead>
                  <tr>
                     <th style={{width:"10%"}}>Fecha</th>
                     <th style={{width:"50%"}}>Descripcion</th>
                     <th style={{width:"30%"}}>Total</th>
                     <th style={{width:"10%"}}>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {compras &&
                     compras?.map((insu) => {
                        if (parseInt(filtroTipo) === parseInt(insu.tipo)) {
                           return (
                              <tr
                                 key={insu.id}
                                 className={
                                    parseInt(insu.cod_status) === 2
                                       ? style.trdatosRed
                                       : style.trdatos
                                 }
                              >
                                 <td className={style.style_code}>
                                    {formatDate(insu.fecha)}
                                 </td>
                                 <td className={style.style_td}>
                                    {insu.titulo}
                                 </td>
                                 <td className={style.precio}>U$S {formatoNumero(insu.total)}</td>
                                 <td className={style.aligncenter}>
                                    <Link
                                       to={"/formCompra"}
                                       className="dLink"
                                       state={{
                                          id_primary: insu.id_primary,
                                          id: insu.id,
                                          companyId: insu.companyId,
                                          cod_status: insu.cod_status,
                                          productos: insu.productos,
                                          insumos: insu.insumos,
                                       }}
                                    >
                                       <Pencil className="lucide" />
                                       {/* <FcAcceptDatabase style={estilo} /> */}
                                    </Link>
                                    &nbsp;&nbsp;
                                    <SquareX
                                       className="lucideIconDel"
                                       onClick={() =>
                                          handleRemove(insu.id_primary)
                                       }
                                    />
                                 </td>
                              </tr>
                           );
                        } else {
                           return null;
                        }
                     })}
               </tbody>
            </table>
         </div>
      </>
   );
};

export default AbmCompras;
